import Missions from "components/templates/missions/Missions";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "MISSIONS",
  label: "Missions",
  Component: Missions,
  initialContents: [
    {
      key: "pageLinks",
      type: elementsTypes.CARDS_LIST,
      value: "",
      children: [],
    },
  ],
};
